export default __webpack_public_path__ + "static/media/lineItem.26cc3543.svg";